import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AppService } from '../../shared/services/app.service';
import { ShareMetaSeoService } from '../../shared/services/share-meta-seo.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { SpinnerService } from '../../shared/services/spinner.service';
import { CookiesNameType } from '../../shared/entities/enums/cookies-name-type';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'gryf-web-app',
  templateUrl: './web-app.component.html',
})
export class WebAppComponent implements OnInit, OnDestroy, AfterViewInit {
  destroy$ = new Subject();
  isGalleryOpen = false;
  showCookiesInfoPanel: boolean;

  constructor(
    private appService: AppService,
    private seoService: ShareMetaSeoService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: SpinnerService,
    private cookieService: CookieService,
  ) {
  }

  ngOnInit(): void {
    this.appService.galleryOpen.pipe(takeUntil(this.destroy$)).subscribe(isOpen => {
      this.isGalleryOpen = isOpen;
    });

    this.appService.showCookiesInfoPanel.pipe(takeUntil(this.destroy$)).subscribe(showCookiesPanel => {
      this.showCookiesInfoPanel = showCookiesPanel;
    });

    if (!this.cookieService.get(CookiesNameType.ANALYTICAL_COOKIES) && !this.cookieService.get(CookiesNameType.PERSONALIZED_ADS)) {
      this.appService.showCookiesInfoPanel.next(true);
    }
  }

  private getChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  ngAfterViewInit(): void {
    this.spinner.hide();
  }

  ngOnDestroy(): void {
    // this.destroy$.next();
    this.destroy$.complete();
  }
}
